import { useReport } from "./hooks/use-context";

export function Header() {
  const { header } = useReport();

  return (
    <div
      style={{
        width: '100%',
        marginBottom: '10px',
        display: 'flex',
        border: '1px solid #CCC',
        color: '#000',
        fontFamily: 'sans-serif'
      }}
    >
      <div style={{ flex: 1, padding: '10px' }}>
        <div style={{ fontSize: '20px', fontWeight: 'bold' }}>FORMU-1112 Análise de Acidentes</div>
        <div style={{ padding: '8px 0', borderBottom: '2px solid orange', minHeight: '10px' }}>
          {/* Empty bar as in the print */}
        </div>
      </div>
      <div
        style={{
          width: '200px',
          padding: '10px',
          borderLeft: '1px solid #CCC',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <img src={header.logo} alt="Goiasa" style={{ maxWidth: '100%', maxHeight: '60px' }} />
      </div>
    </div>
  );
}
